document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('open-box-cross-sell-data');
  if (!dataEl) return;

  var url = dataEl.getAttribute('data-url');
  var price = dataEl.getAttribute('data-price');
  var savings = dataEl.getAttribute('data-savings');
  if (!url || !price) return;

  var BG_URL = 'https://cdn.shopify.com/s/files/1/0112/1743/6730/files/Fondo-smartlup.png?v=1784582036';
  var GREEN = '#C6F964';

  var banner = document.createElement('a');
  banner.href = url;
  banner.className = 'open-box-cross-sell-banner';
  banner.style.cssText = 'position:relative;overflow:hidden;display:block;background-color:#111111;background-image:url(' + BG_URL + ');background-size:cover;background-position:center;background-repeat:no-repeat;border-radius:8px;padding:16px 18px;margin:14px 0;text-decoration:none;font-family:Averta,sans-serif;color:#FFFFFF !important;';

  banner.innerHTML =
    '<span style="position:relative;z-index:1;display:block;color:#FFFFFF !important;">' +
      '<strong style="display:block;font-size:18px;line-height:1.2;margin-bottom:6px;color:#FFFFFF !important;">También disponible en Open Box</strong>' +
      '<span style="font-size:15px;line-height:1.4;color:#FFFFFF !important;">' +
        'Desde <strong style="color:' + GREEN + ' !important;">' + price + '</strong> — ¡Ahorra ' + savings + '! ' +
        '<strong style="color:#FFFFFF !important;text-decoration:underline;text-decoration-color:#FFFFFF !important;">Ver producto →</strong>' +
      '</span>' +
    '</span>';

  var priceBlock = document.querySelector('.modal_price');
  if (priceBlock && priceBlock.parentNode) {
    priceBlock.parentNode.insertBefore(banner, priceBlock.nextSibling);
  } else if (dataEl.parentNode) {
    dataEl.parentNode.insertBefore(banner, dataEl);
  }
});
